import { atom } from 'recoil'

export default atom({
    key: 'imagesGrab',
    default: { grab: false, id: '', properties: {} },
})
